// extracted by mini-css-extract-plugin
export default {"container":"FunnelStageField_container__aSvKP","stageIcon":"FunnelStageField_stageIcon__yz+wU"};